export default __webpack_public_path__ + "static/media/Red-BG-Middle.94cd1c24.svg";